import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Button } from '@fiverr-private/fit';
import DownloadIcon from './download-icon';

import './style.scss';

const Download = ({ className, onClick, text, fill }) => (
    <Button fill={fill}
        size="small"
        data-download-link
        onClick={onClick}
        className={classNames(className, 'btn-download-container')}>
        <DownloadIcon/> {text}
    </Button>
);

Download.propTypes = {
    className: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    text: PropTypes.string,
    fill: PropTypes.string
};

Download.defaultProps = {
    onClick: () => null,
    fill: 'full'
};

export default Download;
